import * as React from 'react';
import NumberFormat from 'react-number-format';

export interface PhoneInputProps {
    className?: string;
    disabled?: boolean;
    id?: string;
    label?: string;
    name?: string;
    tooltip?: string;
    value?: string;
    onBlur?(): void;
    onChange(text: string): void;
}

interface OnChangeValues {
    floatValue: number;
    formattedValue: string;
    value: string;
}

export const PhoneInput: React.FunctionComponent<PhoneInputProps> = (props) => {
    const { className, disabled, id, label, name, value, tooltip, onBlur, onChange } = props;

    const onValueChange = (values: OnChangeValues) => {
        onChange(values.value);
    };

    const textFieldProps = {
        className,
        id,
        label,
        name,
        value,
        tooltip,
        disabled,
        type: 'tel',
        format: '(###) ###-####',
        mask: '_',
        onBlur,
        onValueChange,
    };

    return <NumberFormat {...textFieldProps} />;
};
